import { createFileRoute, notFound } from '@tanstack/react-router';
import { isValidSubNav, type SubnavParam } from './-utils';

type Params = {
  subNav: SubnavParam;
};

export const Route = createFileRoute('/bulk_/$subNav')({
  params: {
    parse: (params): Params => {
      if (!isValidSubNav(params.subNav)) {
        throw notFound();
      }
      return params as Params;
    },
  },
});
